import * as PIXI from 'pixi.js';
import ButtonContainer from './buttonContainer';
import AssetsLoader from '../utils/assetsLoader';

const buttonOptions = {
    'PLAY_CARD': {
        buttonText: 'Play',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.PLAY_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'playCardClicked'
    },
    'GIVE_DON': {
        buttonText: 'Give DON!!',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.GIVE_DON_BUTTON_TEXT,
        // textAssetScale: 0.85,
        eventName: 'giveDonClicked',
    },
    'DECLARE_ATTACK': {
        buttonText: 'Attack',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.DECLARE_ATTACK_BUTTON_TEXT,
        // textAssetScale: 0.85,
        eventName: 'declareAttackClicked'
    },
    'ACTIVATE_EFFECT': {
        buttonText: 'Activate Effect',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.ACTIVATE_EFFECT_BUTTON_TEXT,
        // textAssetScale: 0.85,
        eventName: 'activateEffectClicked'
    },
    'BLOCK': {
        buttonText: 'Block',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.BLOCK_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'blockClicked'
    },
    'COUNTER': {
        buttonText: 'Counter',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.COUNTER_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'counterClicked'
    },
    'RESET': {
        buttonText: 'Reset',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.RESET_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'resetClicked'
    },
    'CONFIRM': {
        buttonText: 'Confirm',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.CONFIRM_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'confirmClicked'
    },
    'KEEP_HAND': {
        buttonText: 'Keep',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.KEEP_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'keepHandClicked'
    },
    'REPLACE_HAND': {
        buttonText: 'Replace',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.RESET_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'replaceHandClicked'
    },
    'KEEP_TRIGGER': {
        buttonText: 'Keep',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.KEEP_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'keepTriggerClicked'
    },
    'ACTIVATE_TRIGGER': {
        buttonText: 'Activate',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.ACTIVATE_TRIGGER_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'activateTriggerClicked'
    },
    'NO_SELECTION': {
        buttonText: 'No Selection',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.NO_SELECTION_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'noSelectionClicked'
    },
    'PLACE_ON_TOP': {
        buttonText: 'Put Top',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.PLACE_ON_TOP_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'placeOnTopClicked'
    },
    'PLACE_ON_BOTTOM': {
        buttonText: 'Put Bottom',
        buttonTextOffsetY: 120,
        buttonTextAssetName: AssetsLoader.eDefaultAssetsAliases.PLACE_ON_BOTTOM_ACTION_BUTTON,
        // textAssetScale: 0.85,
        eventName: 'placeOnBottomClicked'
    }
};

export default class ActionButtonsContainer extends PIXI.Container {

    #width = 600;
    #height = 310;

    constructor() {
        super();

        const actionButtonsBackgroundTexture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.ACTION_BUTTONS_BG);
        const actionButtonsBackgroundSprite = new PIXI.Sprite(actionButtonsBackgroundTexture);
        actionButtonsBackgroundSprite.label = 'background';
        actionButtonsBackgroundSprite.anchor.set(0.5);
        actionButtonsBackgroundSprite.eventMode = 'none';
        this.addChild(actionButtonsBackgroundSprite);

        const titleText = new PIXI.Text({
            text: 'Actions',
            style: {
                fontFamily: 'Open Sans',
                fontSize: 38,
                fill: '#ffffff',
            }
        });
        titleText.label = 'titleText';
        titleText.anchor.set(0.5);
        titleText.x = 0;
        titleText.y = -120;
        this.addChild(titleText);
    }

    update(gameState) {
        if (!gameState.clientGameState.availableActions?.length) {
            return;
        }

        const hasTitle = gameState?.pendingAction?.context?.triggeringPlayerId === gameState?.player?.playerId && (gameState?.pendingAction?.currentStepData?.prompt || gameState?.clientGameState?.overridePrompt);
        const titleText = this.getChildByLabel('titleText');
        titleText.visible = false;
        if (hasTitle) {
            titleText.text = gameState.clientGameState.overridePrompt || gameState.pendingAction.currentStepData.prompt;
            titleText.visible = true;
        }

        if (hasTitle) {
            this.getChildByLabel('background').scale.y = 1.4;
        } else {
            this.getChildByLabel('background').scale.y = 1.2;
        }

        const availableActions = gameState.clientGameState.availableActions;
        
        // Remove all existing button containers
        this.children.filter(child => child instanceof ButtonContainer).forEach(child => child.destroy({ children: true }));

        // Create and position new buttons based on available actions
        availableActions.forEach((action, index) => {
            let actionType;
            let disabled = false;

            if (typeof action === 'string') {
                actionType = action;
            } else if (typeof action === 'object') {
                actionType = action.type;
                disabled = action.disabled;
            }

            const options = buttonOptions[actionType] || {
                buttonText: action.replace(/_/g, ' '),
                bgAssetName: AssetsLoader.eDefaultAssetsAliases.ACTION_BUTTON_BG,
                eventName: action.toLowerCase() + 'Clicked'
            };
            
            const button = new ButtonContainer({ ...options, disabled });
            button.x = (index - (availableActions.length - 1) / 2) * 240;
            button.y = hasTitle ? 5 : -18;
            this.addChild(button);
        });

    
    }

    hideBackground() {
        this.getChildByLabel('background').visible = false;
    }

    showBackground() {
        this.getChildByLabel('background').visible = true;
    }
}


